import React from 'react';
import { Link } from 'react-router-dom';
import { useSettings } from '../../context/SettingsContext';

const SERVICES = [
  { icon: '📱', name: 'Phone Repair', items: ['Screen replacement', 'Battery replacement', 'Charging port repair', 'Camera repair', 'Water damage treatment', 'Speaker & microphone', 'Back glass repair'] },
  { icon: '📟', name: 'Tablet & iPad Repair', items: ['Screen & digitizer', 'Battery replacement', 'Charging port', 'Home button', 'Back housing', 'Software issues'] },
  { icon: '💻', name: 'Laptop & Computer', items: ['Screen replacement', 'Keyboard repair', 'Virus & malware removal', 'Data recovery', 'RAM & SSD upgrades', 'Charging port', 'Battery replacement'] },
  { icon: '🎮', name: 'Gaming Console', items: ['PlayStation repair', 'Xbox repair', 'Nintendo Switch repair', 'HDMI port repair', 'Disc drive repair', 'Controller repair'] },
  { icon: '🔧', name: 'Other Devices', items: ['Smartwatch repair', 'Earbuds & headphones', 'Camera repair', 'Diagnostic services', 'Data transfer', 'General electronics'] },
];

export default function TechRepairPage() {
  const { settings } = useSettings();
  const techPhoneDigits = (settings.screen_savers_phone || '').replace(/\D/g, '');
  const fullAddress = `${settings.store_address}, ${settings.store_city}`;
  return (
    <div>
      <div className="page-hero">
        <h1>Tech Repair Services</h1>
        <p>Professional phone, tablet, laptop, and device repair — fast turnaround</p>
      </div>

      {/* Screen Savers banner */}
      <section style={{ background: '#fff', padding: '32px 0', borderBottom: '1px solid #e8e8e8' }}>
        <div className="container">
          <div style={{ display: 'flex', alignItems: 'center', gap: 28, flexWrap: 'wrap', background: 'linear-gradient(135deg, #1a2744, #243660)', borderRadius: 16, padding: '28px 32px', color: '#fff' }}>
            <div style={{ fontSize: 52 }}>🔧</div>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 12, color: '#c9a227', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: 6 }}>Tech Repair Division</div>
              <h2 style={{ fontSize: 22, fontWeight: 800, marginBottom: 8 }}>Screen Savers Phone Repair</h2>
              <p style={{ color: 'rgba(255,255,255,0.75)', fontSize: 15, lineHeight: 1.6, marginBottom: 12 }}>
                Our tech repair division brings years of professional device repair experience to Natchitoches. From cracked screens to water damage, we fix it fast.
              </p>
              <a href={`tel:${techPhoneDigits}`} style={{ display: 'inline-flex', alignItems: 'center', gap: 8, background: '#c9a227', color: '#1a2744', padding: '10px 22px', borderRadius: 8, fontWeight: 800, fontSize: 15 }}>
                📞 Call {settings.screen_savers_phone}
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Services grid */}
      <section className="section" style={{ background: '#f8f7f2' }}>
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: 40 }}>
            <h2 className="section-title">What We Repair</h2>
            <div className="gold-divider gold-divider-center" />
          </div>
          <div className="grid-3" style={{ gap: 24 }}>
            {SERVICES.map(svc => (
              <div key={svc.name} className="card" style={{ padding: 24 }}>
                <div style={{ fontSize: 36, marginBottom: 12 }}>{svc.icon}</div>
                <h3 style={{ fontSize: 17, fontWeight: 800, color: '#1a2744', marginBottom: 12 }}>{svc.name}</h3>
                <ul style={{ listStyle: 'none', padding: 0 }}>
                  {svc.items.map(item => (
                    <li key={item} style={{ fontSize: 13, color: '#555', padding: '5px 0', borderBottom: '1px solid #f0f0f0', display: 'flex', alignItems: 'center', gap: 8 }}>
                      <span style={{ color: '#c9a227', fontWeight: 700 }}>✓</span> {item}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section" style={{ background: '#1a2744', color: '#fff', textAlign: 'center' }}>
        <div className="container">
          <h2 style={{ fontSize: 28, fontWeight: 800, marginBottom: 12 }}>Ready to Get Your Device Fixed?</h2>
          <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: 16, marginBottom: 28, maxWidth: 480, margin: '0 auto 28px' }}>
            Stop in at {fullAddress}, or call our tech repair line for a free estimate.
          </p>
          <div style={{ display: 'flex', gap: 14, justifyContent: 'center', flexWrap: 'wrap' }}>
            <a href={`tel:${techPhoneDigits}`} className="btn btn-primary btn-lg">📞 Call {settings.screen_savers_phone}</a>
            <Link to="/contact" className="btn btn-outline-gold btn-lg">Contact Us</Link>
          </div>
          <p style={{ color: 'rgba(255,255,255,0.45)', fontSize: 13, marginTop: 20 }}>See full hours on our <Link to="/contact" style={{ color: 'rgba(255,255,255,0.6)' }}>Contact page</Link> · {fullAddress}</p>
        </div>
      </section>
    </div>
  );
}
